import { Paragraph } from 'docx';

// Utils
import { hasValidCertification, isValidCertification } from '@shared/utils';
import { buildCertLine } from '@/utils/certification';
import { bodyRun, sectionHeading } from '../utils';

// Types
import { TemplateProps } from '@/components/template/resume/type';

// Tokens
import { SECTION_TITLES } from '../../tokens';

// Constants
import { LINE_SPACING } from '../constants';

export const CertificatesSection = (
  certs: TemplateProps['data']['certs'],
): Paragraph[] => {
  if (!certs || !hasValidCertification(certs)) return [];

  const validCerts = certs.filter(isValidCertification);

  const paragraphs: Paragraph[] = [
    sectionHeading(SECTION_TITLES.certifications),
  ];

  for (const cert of validCerts) {
    const certLine = buildCertLine(cert?.name ?? '', cert?.issue);

    if (certLine) {
      paragraphs.push(
        new Paragraph({
          spacing: { line: LINE_SPACING },
          children: [bodyRun(certLine)],
        }),
      );
    }
  }

  return paragraphs;
};
